import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    coverageAreaSearchText: null,
    coverageAreaRadius: 100,
    coverageAreaType: null,
    coverageAreaCoordinates: {
      longitude: null,
      latitude: null,
    },
    pagination: {
      page: 0,
      pageSize: 10,
    },
    search: "",
    startDate: "",
    endDate: "",
    minRate: "",
    maxRate: "",
    minRequests: "",
    maxRequests: "",
    categoryId: "",
    vendorId: "",
    subCategoryIds: [],
    paymentType: "",
  },
};

const filtersSlice = createSlice({
  name: "filtersSlice",
  initialState,
  reducers: {
    setJobEngineerFilters: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName === "pagination") {
        state.value.pagination = { ...state.value.pagination, ...data };
      } else {
        state.value[filterName] = data;
      }
    },
    resetJobEngineerFilters: (state) => {
      state.value = { ...initialState.value };
    },
  },
});

export const { setJobEngineerFilters, resetJobEngineerFilters } =
  filtersSlice.actions;

export default filtersSlice.reducer;
